import HeaderAndNavLayout from "./HeaderAndNavLayout";

export default function HeaderWithoutNavLayout({
  children,
}: React.PropsWithChildren<{ withoutNav?: boolean }>): React.JSX.Element {
  return <HeaderAndNavLayout showNav={false}>{children}</HeaderAndNavLayout>;
}
